module.exports = __webpack_public_path__ + "static/img/cont63 (1).e561742.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont63 (1).jpg
// module id = Y+Yc
// module chunks = 0